import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

import { AccountCard } from '../../AccountSettings.style';

export const Card2fa = superstyled({
  tag: AccountCard,
  name: 'TwoStepVerification',
  slot: 'Card2fa',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  }),
});

export const HeaderRow = superstyled({
  tag: Stack,
  name: 'TwoStepVerification',
  slot: 'HeaderRow',
  styles: () => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.5rem',
  }),
});

export const MethodList = superstyled({
  tag: Stack,
  name: 'TwoStepVerification',
  slot: 'MethodList',
  styles: ({ theme }) => ({
    gap: theme.spacing(6),
    paddingInline: theme.spacing(2.5),
  }),
});

export const MethodRow = superstyled({
  tag: Stack,
  name: 'TwoStepVerification',
  slot: 'MethodRow',
  styles: () => ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  }),
});

export const MethodText = superstyled({
  tag: Stack,
  name: 'TwoStepVerification',
  slot: 'MethodText',
  styles: () => ({
    flexGrow: 1,
    gap: '0.125rem',
  }),
});

// The enrolled/not-enrolled background depends on runtime state, so it's applied via `sx`
// at the call site instead of baked into this static style.
export const MethodIcon = superstyled({
  tag: Box,
  name: 'TwoStepVerification',
  slot: 'MethodIcon',
  styles: ({ theme }) => ({
    display: 'flex',
    color: theme.palette.text.primary,
    alignItems: 'center',
    justifyContent: 'center',
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '50%',
    flexShrink: 0,
  }),
});

export const EmptyStateIcon = superstyled({
  tag: SecurityRoundedIcon,
  name: 'TwoStepVerification',
  slot: 'EmptyStateIcon',
  styles: ({ theme }) => ({
    fontSize: '4rem',
    color: theme.palette.text.primary,
  }),
});
